import classNames from 'classnames'
import { useTabsContext } from './Tabs'
import type { PanelProps } from './types'
import { Button } from '../Button'

export const Panel: React.FC<React.PropsWithChildren<PanelProps>> = ({
  index,
  hasNextPanel = false,
  children,
  className,
  forwardButtonLabel,
}) => {
  const { activeTab, id, setActiveTab } = useTabsContext()

  const baseId = `${id}-tab[${index}]`

  const handleForward = () => {
    if (!hasNextPanel) {
      return
    }
    setActiveTab((activeTab ?? 0) + 1)
  }

  const shouldRenderForwardButton = forwardButtonLabel && hasNextPanel

  const forwardButtonSection = shouldRenderForwardButton && (
    <div className="sticky bottom-0 bg-primary w-full flex justify-center border-t pt-6">
      <Button size="md" onClick={handleForward} className="w-full sm:w-auto">
        {forwardButtonLabel}
      </Button>
    </div>
  )

  return (
    <div
      aria-labelledby={`${baseId}-button`}
      className={classNames(className, { hidden: activeTab !== index })}
      id={`${baseId}-panel`}
      role="tabpanel"
      tabIndex={0}
    >
      {shouldRenderForwardButton ? (
        <div className="flex h-full flex-col justify-between relative">
          {children}
          {forwardButtonSection}
        </div>
      ) : (
        children
      )}
    </div>
  )
}
